import { render, staticRenderFns } from "./StudentLayout.vue?vue&type=template&id=464a52af&scoped=true"
import script from "./StudentLayout.vue?vue&type=script&lang=js"
export * from "./StudentLayout.vue?vue&type=script&lang=js"
import style0 from "./StudentLayout.vue?vue&type=style&index=0&id=464a52af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464a52af",
  null
  
)

export default component.exports